import { useQuery, UseQueryOptions } from "react-query";
import { getPhases } from "../../services/scientific/phase";
import { PagedRequestType } from "../../types/PagedResults";
import { Key_phases, PHASES } from "../../utils/constants";


export const useGetPhasesQuery = (data: PagedRequestType,options:any = null ) =>
  useQuery(
    [Key_phases, JSON.stringify(data)],
    () => getPhases(data), 
    options?{...options}:{}
  );
